import arrayChunk from "astrid-helpers/src/arrayChunk";

import useCollectionData from "./useCollectionData";
import useLoadingValues from "./useLoadingValues";

// This is not ideal, but it works... Max 100 ids.
export default function useCollectionDataByIds(firebase, collection, ids, chunkSize = 10) {
	const chunks = arrayChunk(ids || [], chunkSize);

	const [data, loading, error] = useLoadingValues(
		useCollectionData(chunks[0] && collection?.where(firebase.firestore.FieldPath.documentId(), "in", chunks[0])),
		useCollectionData(chunks[1] && collection?.where(firebase.firestore.FieldPath.documentId(), "in", chunks[1])),
		useCollectionData(chunks[2] && collection?.where(firebase.firestore.FieldPath.documentId(), "in", chunks[2])),
		useCollectionData(chunks[3] && collection?.where(firebase.firestore.FieldPath.documentId(), "in", chunks[3])),
		useCollectionData(chunks[4] && collection?.where(firebase.firestore.FieldPath.documentId(), "in", chunks[4])),
		useCollectionData(chunks[5] && collection?.where(firebase.firestore.FieldPath.documentId(), "in", chunks[5])),
		useCollectionData(chunks[6] && collection?.where(firebase.firestore.FieldPath.documentId(), "in", chunks[6])),
		useCollectionData(chunks[7] && collection?.where(firebase.firestore.FieldPath.documentId(), "in", chunks[7])),
		useCollectionData(chunks[8] && collection?.where(firebase.firestore.FieldPath.documentId(), "in", chunks[8])),
		useCollectionData(chunks[9] && collection?.where(firebase.firestore.FieldPath.documentId(), "in", chunks[9])),
	);

	return [data?.flat().filter(Boolean), loading, error];
}
